export default __webpack_public_path__ + "static/media/linkedin-rose.6aad3b28.svg";